const LEAD_STAGE = "LEAD";
const LOST_STAGE = "LOST";
const PAID_CLOSED_STAGE = "PAID_N_CLOSED";
const PAID_HAPPY_STAGE = "PAID_N_HAPPY";

export type JobStatusLabel =
  | "Pending"
  | "In Progress"
  | "Completed"
  | "Cancelled";

export const getStatusFromJobStage = (jobStage: string): JobStatusLabel => {
  if (jobStage === LEAD_STAGE) {
    return "Pending";
  }
  if (jobStage === LOST_STAGE) {
    return "Cancelled";
  }
  if (jobStage === PAID_CLOSED_STAGE || jobStage === PAID_HAPPY_STAGE) {
    return "Completed";
  }
  return "In Progress";
};

export const CUSTOMER_REFERRAL_LEAD_SOURCE = "Customer Referral";

export const isCustomerReferralLeadSource = (leadSource: string): boolean =>
  leadSource === CUSTOMER_REFERRAL_LEAD_SOURCE;
